<!-- Kids -->
@if (isKid && !forceDefaultBanner) { @if (kidType$ | async; as kidType) {
<div class="banner banner--kids bg-primary d-flex align-items-center justify-content-center" role="banner">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="container">
      <img
        class="rounded kids-banner w-100"
        [src]="
          (kidType == 'All-Stars' ? 'kids/banners/allstars/' : 'kids/banners/baller/') + imageName + '.png' | contentAssetImage
        "
        alt=""
      />
    </div>
  </ng-container>
  <ng-container *ifScreenSize="screenSize.Mobile">
    <img
      class="rounded kids-banner w-100"
      [src]="
        (kidType == 'All-Stars' ? 'kids/banners/allstars/' : 'kids/banners/baller/') + imageName + '.png' | contentAssetImage
      "
      alt=""
    />
  </ng-container>
</div>
} }

<!-- Default / Club1901 -->
<ng-container *ifScreenSize="screenSize.Desktop">
  <div
    *ngIf="!isKid || forceDefaultBanner"
    class="banner"
    role="banner"
    [class.banner--club1901]="isClub1901"
    [style.backgroundImage]="isClub1901 ? null : 'url(' + ('banners/banner.png' | contentAssetImage) + ')'"
  >
    <div class="container d-flex align-items-center h-100 justify-content-center">
      <h5 class="text-white fw-bold text-uppercase mb-0" [ngClass]="isClub1901 ? 'club1901-title' : ''">{{ pageName }}</h5>
    </div>
  </div>
</ng-container>
